import { createContext, useContext } from 'react'

/**
 * Closes the menu. Asked by default, as Esc does: a menu with unsaved changes asks first, and stays
 * open if the author cancels. `force` closes it without asking, for when it can't stay anyway.
 * `discard` also skips its onClose (where a menu saves what's still pending), for when what it was
 * editing has gone: the page or view it belonged to has changed, and a save would land on the new one.
 */
export type MenuClose = (options?: { force?: boolean; discard?: boolean }) => void

// Provided by <Menu>, so its own controls (a ✕, say) close it the way Esc does.
export const MenuCloseContext = createContext<MenuClose | null>(null)

export const useMenuClose = (): MenuClose | null => useContext(MenuCloseContext)
